// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1r75g","content":"styles_content__Xf7nc"};